import React from "react";
import "./servicedesc.css";

const ServiceDesc = ({serviceDes,
  description,
  stats = [],
  ctaText = "VIEW OUR CASE STUDIES",
  ctaHref = "#",
}) => {
  return (
    <section className={`servicedes-section ${serviceDes.class}`}>
      <div className="container servicedes-section__inner">

        {/* Description */}
        <div className="servicedes-section__description">
          {serviceDes.description}
        </div>

        {/* Stats */}
        <div className="servicedes-section__stats">
          {serviceDes.stats.map((item, index) => (
            <div className="servicedes-stat" key={index}>
              <div className="servicedes-stat__title">
                {item.title}
              </div>

              <div className="servicedes-stat__text">
                {item.text}
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        { serviceDes.cta ? (
          <div className="servicedes-section__cta">
            {/* <a href={serviceDes.cta.href}> */}
            <a href="#case-study">
              {serviceDes.cta.text} <span>→</span>
            </a>
          </div>

        ) : "" }

      </div>
    </section>
  );
};

export default ServiceDesc;